import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, Button } from '@origo/origo-ui';
import type { ProcessingFormValues } from '../../../types';
import ProcessingForm, { type ProcessingFieldErrors, type ProcessingFormOptions } from './ProcessingForm';
import styles from './NewProcessingDialog.module.css';

interface NewProcessingDialogProps {
    open: boolean;
    values: ProcessingFormValues;
    fieldErrors: ProcessingFieldErrors;
    options: ProcessingFormOptions;
    onChange: (field: keyof ProcessingFormValues, value: string) => void;
    onClose: () => void;
    onSave: () => void;
    isSaving?: boolean;
}

/** Opprett ny planbehandling (#14408). Native <dialog> via origo-ui Dialog. */
const NewProcessingDialog: React.FC<NewProcessingDialogProps> = ({
    open,
    values,
    fieldErrors,
    options,
    onChange,
    onClose,
    onSave,
    isSaving = false,
}) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            title={t('processings.new.title')}
            className={styles.dialog}
            footer={
                <div className={styles.footer}>
                    <Button variant="secondary" onClick={onClose} disabled={isSaving}>
                        {t('common.cancel')}
                    </Button>
                    <Button variant="primary" onClick={onSave} disabled={isSaving}>
                        {t('processings.new.submit')}
                    </Button>
                </div>
            }
        >
            <ProcessingForm
                values={values}
                options={options}
                fieldErrors={fieldErrors}
                onChange={onChange}
                isSaving={isSaving}
            />
        </Dialog>
    );
};

export default NewProcessingDialog;
